/* Naremi: traduce al español el formulario de pago al recibir (Releasit)
   y lo abre solo al llegar con ?comprar=1 en la dirección. */
(function () {
  var MT_TRAD = [
    [/^CASH ON DELIVERY$/i, 'COMPLETA TU PEDIDO · PAGA AL RECIBIR'],
    [/^Enter your shipping address$/i, 'Ingresa tus datos de envío'],
    [/^Shipping method$/i, 'Método de envío'],
    [/^Shipping$/i, 'Envío'],
    [/^Free$/i, 'Gratis'],
    [/^Discounts?$/i, 'Descuento'],
    [/^Discount code$/i, 'Código de descuento'],
    [/^Apply$/i, 'Aplicar'],
    [/^First name$/i, 'Nombre'],
    [/^Last name$/i, 'Apellido'],
    [/^Full name$/i, 'Nombre y apellido'],
    [/^Phone number$/i, 'Teléfono (WhatsApp)'],
    [/^Phone$/i, 'Teléfono'],
    [/^Address 2$/i, 'Depto / casa / referencia'],
    [/^Address$/i, 'Dirección'],
    [/^City$/i, 'Comuna'],
    [/^Email$/i, 'Correo'],
    [/^Order note$/i, 'Nota del pedido'],
    [/This field is required\.?/i, 'Este campo es obligatorio.'],
    [/Enter a valid phone number\.?/i, 'Ingresa un teléfono válido.'],
    [/Enter a valid email address\.?/i, 'Ingresa un correo válido.'],
    [/Enter a valid discount code\.?/i, 'Ingresa un código válido.'],
    [/Enter a valid value\.?/i, 'Ingresa un valor válido.'],
    [/Only 1 discount per order is allowed\.?/i, 'Solo se permite 1 descuento por pedido.'],
    [/COMPLETE ORDER/i, 'CONFIRMAR PEDIDO'],
    [/^Processing\.*$/i, 'Procesando...'],
    [/^Thank you!?$/i, '¡Gracias!']
  ];
  function traducirTexto(t) {
    var limpio = t.trim();
    if (!limpio) return t;
    for (var i = 0; i < MT_TRAD.length; i++) {
      if (MT_TRAD[i][0].test(limpio)) return t.replace(limpio, limpio.replace(MT_TRAD[i][0], MT_TRAD[i][1]));
    }
    return t;
  }
  function traducirEn(raiz) {
    if (!raiz || !raiz.querySelectorAll) return;
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = w.nextNode())) {
      var nuevo = traducirTexto(n.nodeValue);
      if (nuevo !== n.nodeValue) n.nodeValue = nuevo;
    }
    raiz.querySelectorAll('[placeholder]').forEach(function (el) {
      var p = el.getAttribute('placeholder');
      var np = traducirTexto(p);
      if (np !== p) el.setAttribute('placeholder', np);
    });
  }
  /* Texto del botón en dos líneas: "SÍ, LO QUIERO" + "Pago al recibir" */
  function rotularBotones() {
    document.querySelectorAll('._rsi-buy-now-button').forEach(function (b) {
      b.style.setProperty('background-color', '#1F9D55', 'important');
      b.style.setProperty('border-color', '#1F9D55', 'important');
    });
    document.querySelectorAll('._rsi-buy-now-button span').forEach(function (s) {
      if (s.querySelector('.mt-rsi-label') || !/paga al recibir/i.test(s.textContent)) return;
      s.innerHTML = '<span class="mt-rsi-label"><strong>SÍ, LO QUIERO</strong><small>Pago al recibir</small></span>';
    });
  }
  function initTraduccion() {
    var pendiente = false;
    function pasar() {
      pendiente = false;
      document.querySelectorAll('[class*="_rsi-modal"], [class*="_rsi-cod-form"]').forEach(traducirEn);
      rotularBotones();
    }
    new MutationObserver(function () {
      if (!pendiente) { pendiente = true; requestAnimationFrame(pasar); }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    pasar();
  }
  function initAutoComprar() {
    if (!/[?&]comprar=1/.test(window.location.search)) return;
    var intentos = 0;
    var t = setInterval(function () {
      intentos++;
      var btn = null;
      document.querySelectorAll('._rsi-buy-now-button').forEach(function (b) {
        if (!btn && b.offsetParent !== null && !b.closest('._rsi-buy-now-button-floating')) btn = b;
      });
      if (btn) {
        clearInterval(t);
        /* ?pack=N: elegir esa cantidad en las tarjetas de packs antes de abrir el formulario */
        var pack = (window.location.search.match(/[?&]pack=(\d+)/) || [])[1];
        if (pack) {
          var op = null;
          document.querySelectorAll('.quantity-break[data-quantity="' + pack + '"]').forEach(function (l) {
            if (!op && l.offsetParent !== null) op = l;
          });
          if (op) op.click();
        }
        btn.scrollIntoView({ block: 'center' });
        setTimeout(function () { btn.click(); }, 300);
      } else if (intentos > 40) {
        clearInterval(t);
      }
    }, 250);
  }
  document.addEventListener('DOMContentLoaded', function () {
    initTraduccion();
    initAutoComprar();
  });
})();
